import { Divider, Link as MuiLink, Stack } from '@mui/material'

interface FooterPolicyLinksProps {}

export const FooterPolicyLinks = ({}: FooterPolicyLinksProps) => {
  const policies = [
    'Chính sách bảo mật',
    'Chính sách đổi trả',
    'Chính sách giao hàng',
    'Chính sách thanh toán',
    'Chính sách khuyến mãi',
    'Chính sách affiliate',
  ]

  return (
    <Stack
      direction="row"
      spacing={2}
      flexWrap={'wrap'}
      divider={<Divider orientation="vertical" flexItem sx={{ bgcolor: '#BBBBBA' }} />}
      sx={{ mt: 'auto' }}
    >
      {policies.map((policy, index) => (
        <MuiLink
          key={index}
          component="button"
          sx={{
            fontSize: '14px',
            fontWeight: index === 0 ? 600 : 300,
            textDecoration: 'none',
            cursor: 'pointer',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          {policy}
        </MuiLink>
      ))}
    </Stack>
  )
}
